<template>
  <div class="jobs-page">
    <div class="jobs-page-title">
      <p>基于对比报告为你推荐了以下职位，投递试试吧</p>
      <a class="more-btn" :href="`/jobs/search?is_search=true&keyword=${professionName}`" target="_blank">更多职位</a>
    </div>
    <div class="jobs-list" >
      <template v-if="jobList.length > 0">
        <div class="job-item-box" v-for="(item, index) in jobList" :key="index + 'job'" @click.stop="handleClickToDetail(item)"  data-growing-container :data-growing-idx="70 + index">
          <div class="job-post-name-box">
            <p class="post-name">{{item.job_post}}</p>
            <p class="salary">{{item.display_salary}}</p>
          </div>
          <div class="job-tags">
            <div class="tag">{{item.city_names && item.city_names[0] || '全国'}}</div>
            <div class="tag">{{item.display_experience || '不限'}}</div>
            <div class="tag">{{item.degree_name || '不限'}}</div>
          </div>
          <div class="company-info">
            <img  :src="item.company_logo"/>
            <span>{{item.company_nick_name || item.company_name}}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="not-data-box">
          <img src="https://files.wondercv.com/PC/editor/planning/company/default.png" alt="">
          <p>暂无相关内推职位</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import api from "../../../api";
  export default {
    name: "detail-recommend-jobs",
    props: {
      professionName: {
        type: String,
        default: ""
      },
      profession_id_prop:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        jobList: []
      }
    },
    created() {
      this.getJobList()
    },
    watch:{
      profession_id_prop:{
        handler(val){
          this.getJobList()
        }
      }
    },
    methods: {
      getJobList(){
        let profession_ids = this.$route.name === 'planning-detail' ? this.$route.params.token : this.$route.query.profession_id
        let resume_token = this.$route.query.me_token
        if(this.profession_id_prop) profession_ids = this.profession_id_prop
        api.recommend.careerToJob({
          jd_flag: 2,
          page: 1,
          size: 6,
          resume_token,
          intention_id: profession_ids
        }).then(res => {
          console.log(res)
          if(res.code === 1000){
            this.jobList = res.data && res.data.jobs && res.data.jobs.slice(0, 6)
          }
        })
        // api.planning.getRecommendList({
        //   jd_flag: 2,
        //   from: 0,
        //   size: 6,
        //   resume_flag: 0,
        //   resume_token,
        //   profession_ids
        // }).then(res => {
        //   console.log(res)
        //   if(res.code === 1000){
        //     this.jobList = res.data && res.data.jobs && res.data.jobs.slice(0, 6)
        //   }
        // })
      },
      handleClickToDetail(job){
        window.open(`/jobs/${job.token}.html`)
      }
    }
  }
</script>

<style scoped lang="scss">
.jobs-page{
  .jobs-page-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 34px;
    & > p{
      font-size: 32px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 45px;
    }
    .more-btn{
      width: 96px;
      height: 32px;
      background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
      border-radius: 16px;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 32px;
    }
  }
  .jobs-list{
    width: 1200px;
    height: 364px;
    box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
    border-radius: 12px;
    background-image: url("https://files.wondercv.com/PC/editor/planning/jobs/bgcard4.png");
    background-size: 100%;
    display: flex;
    gap: 22px;
    flex-wrap: wrap;
    padding: 32px;
    box-sizing: border-box;
    .content-box{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
    }
    .job-item-box{
      width: 364px;
      height: 139px;
      background: #252830;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 20px 24px;
      box-sizing: border-box;
      cursor: pointer;
      .job-post-name-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .post-name{
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 25px;
          flex: 1;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .salary{
          font-size: 18px;
          font-weight: 500;
          color: #FE7B5D;
          line-height: 25px;
          margin-left: 10px;
        }
      }
    }
    .job-tags{
      display: flex;
      margin-bottom: 12px;
      .tag{
        padding: 6px 10px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
        font-size: 12px;
        font-weight: 300;
        color: rgba(255, 255, 255, 0.8);
        line-height: 12px;
        margin-right: 6px;
      }

    }
    .company-info{
      display: flex;
      align-items: center;
      & > img{
        width: 28px;
        height: 28px;
        margin-right: 12px;
        border-radius: 2px;
      }
      & > span{
        font-size: 14px;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 14px;
        flex: 1;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }
  .not-data-box{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #252830;
    border-radius: 8px;
    img{
      width: 74px;
      height: 74px;
      margin-bottom: 18px;
    }
    p{
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 14px;
      text-align: center;
    }
  }
}
</style>
